export const EXTENSION_CLOSE_WINDOW_COOKIE_NAME = "mem_close_window_after_auth";
